/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* globals angular $ */
import intl from 'react-intl-universal'
import _ from 'lodash'

import { setStoryAns } from '~/redux/storyData'
import template from './template.html'

export default {
  restrict: 'E',
  template,
  replace: true,
  bindings: {
    storyObj: '=',
    sitesObj: '=',
  },
  controllerAs: 'vm',
  controller: ['$rootScope', '$ngRedux', ImageFocalPoint],
}

function ImageFocalPoint($rootScope, $ngRedux) {
  this.intl = intl
  let activeFeature = null // the ANS object of the selected image
  let activeFeatureAnsPath
  this.isActive = false // shows and hides the modal depending on state
  this.hasFocalPoint = false // set when ANS is loaded to determine is remove button should be shown
  this.zoomLevel = '1' // The zoom level value for the select element
  this.focal = {
    // holds the focal coordinates for the image
    x: undefined,
    y: undefined,
  }
  this.imageDetails = {} // when selected, holds the image path, width, and height
  this.isError = false

  // set image proportions based on zoom level
  this.getCurrentWidth = () =>
    Math.round(this.imageDetails.width * Number(this.zoomLevel)) + 'px'
  this.getCurrentSource = () => this.imageDetails.src

  // called by on click on the wrapper, uses zoom level to get actual x/y coords
  this.setFocalPoint = (event) => {
    this.focal.x = Math.round(event.offsetX * (1 / Number(this.zoomLevel)))
    this.focal.y = Math.round(event.offsetY * (1 / Number(this.zoomLevel)))
  }

  // This returns the focal point x/y position based on zoom level
  this.getFocalPosition = () => {
    return {
      x: Math.round(this.focal.x * Number(this.zoomLevel) - 4) + 'px',
      y: Math.round(this.focal.y * Number(this.zoomLevel) - 18) + 'px',
    }
  }

  // hides the modal when called
  const closeModal = () => {
    this.isActive = false
    activeFeatureAnsPath = undefined
    activeFeature = null
    unbindListener()
  }

  // save to the model with the focal point data
  this.updateModel = () => {
    this.isError = this.focal.x === null || this.focal.y === null
    if (this.isError) {
      return
    }

    const writeTo = activeFeature.referent_properties
      ? activeFeature.referent_properties
      : activeFeature

    // TODO: Eric - I am not sure why I am needing to update both places, I will investigate further.

    // ANS has min and max to support range in the future, currently we are only setting one point, not the range.
    writeTo.additional_properties = writeTo.additional_properties || {}
    writeTo.additional_properties.focal_point = {
      min: [this.focal.x, this.focal.y],
      max: [this.focal.x, this.focal.y],
    }

    // forward compatibility
    // https://github.com/washingtonpost/ans-schema/blob/master/src/main/resources/schema/ans/0.10.9/image.json
    writeTo.focal_point = { x: this.focal.x, y: this.focal.y }

    activeFeature.additional_properties =
      activeFeature.additional_properties || {}
    activeFeature.additional_properties.focal_point = {
      min: [this.focal.x, this.focal.y],
      max: [this.focal.x, this.focal.y],
    }

    // forward compatibility
    // https://github.com/washingtonpost/ans-schema/blob/master/src/main/resources/schema/ans/0.10.9/image.json
    activeFeature.focal_point = { x: this.focal.x, y: this.focal.y }

    const storyClone = _.cloneDeep(this.storyObj)
    _.set(storyClone, activeFeatureAnsPath, activeFeature)
    storyClone.isDirty = true
    $ngRedux.dispatch(
      setStoryAns({
        storyAns: storyClone,
        isDirty: true,
      })
    )

    closeModal()
  }

  // delete the focal point data for the image
  this.removeFocalPoint = () => {
    if (
      activeFeature.referent_properties &&
      activeFeature.referent_properties.additional_properties
    ) {
      delete activeFeature.referent_properties.additional_properties.focal_point
    }
    // forward compatibility
    delete activeFeature.referent_properties.focal_point
    if (activeFeature.additional_properties) {
      delete activeFeature.additional_properties.focal_point
    }
    // forward compatibility
    delete activeFeature.focal_point

    const storyClone = _.cloneDeep(this.storyObj)
    _.set(storyClone, activeFeatureAnsPath, activeFeature)
    storyClone.isDirty = true
    $ngRedux.dispatch(
      setStoryAns({
        storyAns: storyClone,
        isDirty: true,
      })
    )

    closeModal()
  }

  // called by the X and cancel buttons
  this.cancelModel = closeModal

  // The feature has buttons that triggers hte Handle Commands, we check for the focal point sub type
  $rootScope.$on('DISPATCH', (info, action) => {
    if (
      action.type === 'HANDLE_COMMANDS' &&
      action.sub_type === 'set-focal-point'
    ) {
      activeFeatureAnsPath = action.featureAnsPath
      // set the active feature so we can write to it when we save
      activeFeature = action.feature

      this.isError = false

      // grab the details for the image we need so we are not touching the model directly
      this.imageDetails = {
        src: activeFeature.additional_properties.proxyUrl,
        width: activeFeature.width,
        height: activeFeature.height,
      }
      // see if the image already has a focal point set in its ANS data.
      let currentFocal
      if (activeFeature.focal_point) {
        // forward compatibility
        // https://github.com/washingtonpost/ans-schema/blob/master/src/main/resources/schema/ans/0.10.9/image.json
        currentFocal = {
          min: [activeFeature.focal_point.x, activeFeature.focal_point.y],
          max: [activeFeature.focal_point.x, activeFeature.focal_point.y],
        }
      } else if (activeFeature.referent_properties.focal_point) {
        // forward compatibility
        // https://github.com/washingtonpost/ans-schema/blob/master/src/main/resources/schema/ans/0.10.9/image.json
        currentFocal = {
          min: [
            activeFeature.referent_properties.focal_point.x,
            activeFeature.referent_properties.focal_point.y,
          ],
          max: [
            activeFeature.referent_properties.focal_point.x,
            activeFeature.referent_properties.focal_point.y,
          ],
        }
      } else {
        currentFocal = (activeFeature.referent_properties &&
          activeFeature.referent_properties.additional_properties &&
          activeFeature.referent_properties.additional_properties
            .focal_point) ||
          (activeFeature.additional_properties &&
            activeFeature.additional_properties.focal_point) || {
            min: [],
            max: [],
          }
      }
      this.focal = {
        x: currentFocal.min[0],
        y: currentFocal.min[1],
      }

      // if we have a focal point, than enable the delete button
      this.hasFocalPoint =
        ((activeFeature.referent_properties &&
          activeFeature.referent_properties.additional_properties &&
          activeFeature.referent_properties.additional_properties
            .focal_point) ||
          (activeFeature.additional_properties &&
            activeFeature.additional_properties.focal_point)) !== undefined

      // set modal height
      setDialogHeight()
      bindListener()

      // show the modal
      this.isActive = true
    }
  })

  const setDialogHeight = () => {
    // tried to do this without an element reference, but would not update dyanamically
    angular
      .element('.focalWrapper')
      .css('height', Math.round(window.innerHeight * 0.7) + 'px')
  }

  const bindListener = () => {
    $(window).on('resize.focalpoint', setDialogHeight)
  }

  const unbindListener = () => {
    $(window).off('resize.focalpoint', setDialogHeight)
  }
}
